import { MdLink } from 'react-icons/md';

type DataLinkProps = {
  url: string;
};

export const DataLink = ({ url }: DataLinkProps) => {
  const normalizedUrl = url.trim();
  const href = /^https?:\/\//i.test(normalizedUrl) ? normalizedUrl : `https://${normalizedUrl}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      title={normalizedUrl}
      className="flex min-w-0 max-w-full items-center gap-2 overflow-hidden text-info-30 text-m-r"
    >
      <MdLink size={24} className="shrink-0" />
      <span className="min-w-0 flex-1 truncate">{normalizedUrl}</span>
    </a>
  );
};
